/**
 * Waits for variable to exist
 * @param  {object}   name   Variable that you're waiting for
 * @param  {function} callback  Function that runs after variable has been found
 */
const whenReady = (name, callback) => {
    var interval = 10; // ms
    window.setTimeout(function() {
        if (window[name]) {
            callback(window[name]);
        } else {
            whenReady(name, callback);
        }
    }, interval);
}